import { dashboardApi } from '@/api';
import { DashboardRule, OptimisationBase } from '@/optimizer';

export type CampaignStateRule = DashboardRule & {
    originalValue: string;
    isScalable: boolean;
    calculatedCampaignValue?: string;
    isCampaignVariable: boolean;
};

type CampaignConfig = {
    key: string;
    value: string;
};

export type CampaignResponse = {
    id: string;
    name: string;
    startDate: Date;
    endDate: Date;
    budget: number;
    optimizationBase: OptimisationBase;
    status: string;
    config: CampaignConfig[];
    customerRules: DashboardRule[];
    internalRules: DashboardRule[];
    campaignStateRules?: CampaignStateRule[];
    disabledChannels?: string[];
};

export const fetchCampaign = async (projectId: string, campaignId: string) =>
    dashboardApi<CampaignResponse>({
        method: 'GET',
        url: `/customer-campaign/project/${projectId}/campaigns/${campaignId}`,
    });
